// Service type definitions for DI container
export const TYPES = {
  // Repositories
  AuthRepository: Symbol.for('AuthRepository'),
  DriverRepository: Symbol.for('DriverRepository'),
  RideRepository: Symbol.for('RideRepository'),
  SolicitationRepository: Symbol.for('SolicitationRepository'),

  // HTTP Clients
  GraphQLClient: Symbol.for('GraphQLClient'),
  AxiosClient: Symbol.for('AxiosClient'),

  // Application Services
  AuthService: Symbol.for('AuthService'),
  DriverService: Symbol.for('DriverService'),
  RideService: Symbol.for('RideService'),
  SolicitationService: Symbol.for('SolicitationService'),
  AnalyticsService: Symbol.for('AnalyticsService'),

  // Queries
  AuthenticateQuery: Symbol.for('AuthenticateQuery'),
  CheckAuthQuery: Symbol.for('CheckAuthQuery'),
  GetDriversQuery: Symbol.for('GetDriversQuery'),
  GetDriverAggregatesQuery: Symbol.for('GetDriverAggregatesQuery'),
  GetRidesQuery: Symbol.for('GetRidesQuery'),
  GetRideAggregatesQuery: Symbol.for('GetRideAggregatesQuery'),
  GetSolicitationAggregatesQuery: Symbol.for('GetSolicitationAggregatesQuery'),

  // Use Cases - Authentication
  LoginUseCase: Symbol.for('LoginUseCase'),
  LogoutUseCase: Symbol.for('LogoutUseCase'),
  RefreshTokenUseCase: Symbol.for('RefreshTokenUseCase'),

  // Use Cases - Drivers
  GetDriverListUseCase: Symbol.for('GetDriverListUseCase'),
  GetDriverDetailsUseCase: Symbol.for('GetDriverDetailsUseCase'),
  GetDriverPerformanceUseCase: Symbol.for('GetDriverPerformanceUseCase'),
  GetDriverOnlineTimeUseCase: Symbol.for('GetDriverOnlineTimeUseCase'),

  // Use Cases - Rides
  GetRideHistoryUseCase: Symbol.for('GetRideHistoryUseCase'),
  GetDashboardDataUseCase: Symbol.for('GetDashboardDataUseCase'),
  GetSolicitationMetricsUseCase: Symbol.for('GetSolicitationMetricsUseCase'),

  // Use Cases - Analytics
  GetAnalyticsUseCase: Symbol.for('GetAnalyticsUseCase'),

  // Legacy Use Cases (for compatibility)
  AuthenticateUseCase: Symbol.for('AuthenticateUseCase'),
  GetDriversUseCase: Symbol.for('GetDriversUseCase'),
  GetDriverUseCase: Symbol.for('GetDriverUseCase'),
  GetRidesUseCase: Symbol.for('GetRidesUseCase'),
  GetDriverAggregatesUseCase: Symbol.for('GetDriverAggregatesUseCase'),
  GetRideAggregatesUseCase: Symbol.for('GetRideAggregatesUseCase'),

  // Cache
  CacheService: Symbol.for('CacheService'),

  // Configuration
  ApiConfig: Symbol.for('ApiConfig'),
  GraphQLConfig: Symbol.for('GraphQLConfig'),
} as const

export type ServiceTypes = (typeof TYPES)[keyof typeof TYPES]
